import { render, staticRenderFns } from "./PermissionSodRiskOverview.vue?vue&type=template&id=c7adec08&scoped=true"
import script from "./PermissionSodRiskOverview.vue?vue&type=script&lang=js"
export * from "./PermissionSodRiskOverview.vue?vue&type=script&lang=js"
import style0 from "./PermissionSodRiskOverview.vue?vue&type=style&index=0&id=c7adec08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7adec08",
  null
  
)

export default component.exports